import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-cancel-pay-popup',
  templateUrl: './cancel-pay-popup.component.html',
  styleUrls: ['./cancel-pay-popup.component.css']
})
export class CancelPayPopupComponent implements OnInit {

  logoFile: any;

  constructor() { }

  ngOnInit(): void {
    this.logoFile = sessionStorage.getItem('logoFile');
  }

  public createImgPath = (serverPath: string) => {
    if(serverPath == null || serverPath == '' || serverPath == undefined) {
      return "../../../assets/images/final automated.png";
    }
    return environment.BaseApiUrl + `/Customer/image?fileName=${serverPath}`;
  }

}
